export const SET_SHIPPING_ADDRESSES = 'SET_SHIPPING_ADDRESSES'
export const SET_DEFAULT_CARRIER_ID = 'SET_DEFAULT_CARRIER_ID'
